/**
 * Faz 9 hata metinleri — Almanca (yapay zekâ, İçerik Stüdyosu, SEO önerileri, YouTube…). Vitrin girişi de hata
 * metinlerini gördüğü için `shared.de.ts` → `errorsDe` içine yayılır (Faz 8 düzeniyle aynı; panel metinleri `ai.de.ts`'de).
 * Terimler: docs/I18N_GLOSSARY.md.
 */
export const aiErrorsDe = {
  youtube_not_configured:
    'YouTube ist nicht verbunden oder nicht getestet. Geben Sie den API-Schlüssel im Bereich Integrationen ein und testen Sie ihn.',
  youtube_key_format:
    'Das API-Schlüsselformat ist falsch (Google Cloud → Anmeldedaten → API-Schlüssel; beginnt mit „AIza“, 39 Zeichen).',
  youtube_key_invalid: 'Google hat diesen API-Schlüssel nicht akzeptiert.',
  youtube_key_restricted:
    'Der Schlüssel ist eingeschränkt: Eine Browser- (HTTP-Referrer) oder App-Einschränkung verhindert die Nutzung durch den Server. Verwenden Sie eine IP-Einschränkung und beschränken Sie den Schlüssel auf die YouTube Data API.',
  youtube_api_disabled:
    'YouTube Data API v3 ist im Google-Cloud-Projekt nicht aktiviert. Aktivieren Sie sie in der API-Bibliothek.',
  youtube_quota: 'Das YouTube-Tageskontingent ist aufgebraucht; versuchen Sie es morgen erneut.',
  youtube_unreachable:
    'YouTube ist nicht erreichbar oder die Antwort konnte nicht gelesen werden. Versuchen Sie es später erneut.',
  merchant_title_claims:
    'Der Google-Titel darf keine Aussagen zur Vorbeugung oder Behandlung von Krankheiten enthalten.',
  merchant_title_too_long: 'Der Google-Titel darf höchstens 150 Zeichen lang sein.',
  copilot_days: 'Der Zeitraum muss 7, 30 oder 90 Tage betragen.',
  copilot_question_required: 'Ihre Frage muss mindestens 3 Zeichen lang sein.',
  ai_translation_source_invalid: 'Der Quellbeitrag gehört nicht zur Übersetzungsgruppe dieses Beitrags.',
  ai_translation_too_long:
    'Der Beitrag ist zu lang, um ihn in einem Durchgang zu übersetzen (max. 40.000 Zeichen).',
  ai_email_goal_required: 'Beschreiben Sie das Kampagnenziel mit mindestens 10 Zeichen.',
  ai_support_drafts_disabled:
    'Support-Antwortentwürfe sind ausgeschaltet. Der Inhaber kann sie in den KI-Einstellungen einschalten (die Kundennachricht wird maskiert gesendet).',
  studio_image_alt_required:
    'Jedes in den Entwurf eingefügte Bild braucht einen Alt-Text: ![Alt-Text](zt-file:…).',
  ai_image_prompt_invalid: 'Die Bildbeschreibung muss 10 bis 1000 Zeichen lang sein.',
  ai_image_invalid:
    'Das vom Anbieter gelieferte Bild konnte nicht gelesen werden; falls es berechnet wurde, erscheint es im Nutzungsbericht. Versuchen Sie es erneut.',
  ai_provenance_locked: 'Die Quelle eines KI-generierten Bildes kann nicht geändert werden.',
  file_not_image: 'Die Datei ist kein Bild.',
  studio_image_limit: 'Es können höchstens 20 Inhaltsbilder hinzugefügt werden.',
  studio_topic_required: 'Das Thema muss mindestens 3 Zeichen lang sein.',
  studio_country_invalid: 'Das Land muss ein zweistelliger Code sein (z. B. TR).',
  studio_source_url_invalid: 'Die Quelle muss eine gültige URL mit http:// oder https:// sein.',
  studio_too_many_sources: 'Es können höchstens 20 Quellen hinzugefügt werden.',
  studio_draft_too_long: 'Der Entwurf darf höchstens 100.000 Zeichen lang sein.',
  studio_path_invalid: 'Ein interner Link muss ein Pfad der Website sein, der mit „/“ beginnt.',
  studio_archived: 'Das Projekt ist archiviert und kann nicht geändert werden.',
  studio_draft_empty: 'Schreiben Sie vor der Übertragung einen Entwurf.',
  studio_draft_invalid:
    'Der Entwurf konnte nicht in das Blogformat umgewandelt werden (zu lang oder zu viele Elemente).',
  studio_no_sources: 'Keine Quellen zum Prüfen. Fügen Sie zuerst Quellen hinzu und speichern Sie.',
  studio_overwrite_confirm: 'Dieses Feld enthält bereits Inhalt; bestätigen Sie das Überschreiben.',
  studio_headings_required:
    'Schreiben Sie vor dem Entwurf die Überschriften oder erstellen Sie mit KI einen Plan.',
  ai_output_invalid:
    'Die KI-Antwort hatte nicht das erwartete Format; es wurde nichts geändert. Versuchen Sie es erneut.',
  ai_not_configured:
    'Kein KI-Anbieter verbunden (Einrichtung erforderlich). Geben Sie den Schlüssel im Bereich Integrationen ein und testen Sie die Verbindung.',
  ai_not_enabled:
    'KI ist ausgeschaltet. Der Geschäftsinhaber muss in den KI-Einstellungen ein Monatslimit festlegen und ausdrücklich zustimmen.',
  ai_budget_exceeded:
    'Monatliches KI-Ausgabenlimit erreicht (Limit {{limit}} USD, ausgegeben {{spent}} USD). Sie können es in den KI-Einstellungen erhöhen.',
  ai_daily_limit: 'Tägliches KI-Anfragelimit ({{limit}}) erreicht. Versuchen Sie es morgen erneut.',
  ai_invalid_key: 'Der Anbieter hat den API-Schlüssel abgelehnt. Erneuern Sie ihn im Bereich Integrationen.',
  ai_invalid_settings: 'Der API-Schlüssel ist leer oder fehlerhaft.',
  ai_provider_rate_limited:
    'Das Ratenlimit des Anbieters wurde erreicht. Versuchen Sie es in einigen Minuten erneut.',
  ai_provider_overloaded: 'Der Anbieter ist gerade ausgelastet. Versuchen Sie es gleich erneut.',
  ai_provider_rejected:
    'Der Anbieter hat die Anfrage abgelehnt (Modellname oder eine Einstellung ist möglicherweise falsch).',
  ai_provider_timeout:
    'Der Anbieter hat nicht rechtzeitig geantwortet. Der reservierte Betrag wurde angerechnet, da die Anfrage möglicherweise verarbeitet wurde.',
  ai_provider_unreachable: 'Der Anbieter ist nicht erreichbar. Versuchen Sie es gleich erneut.',
  ai_provider_bad_response: 'Die Antwort des Anbieters konnte nicht gelesen werden.',
  ai_output_empty:
    'Die KI hat eine leere Antwort geliefert. Ändern Sie die Eingabe und versuchen Sie es erneut.',
  ai_refused: 'Die KI hat diese Anfrage abgelehnt. Ändern Sie die Eingabe und versuchen Sie es erneut.',
  ai_model_price_missing:
    'Der Preis des Modells „{{model}}“ ist unbekannt. Fügen Sie ihn zuerst der Preistabelle hinzu.',
  ai_model_invalid: 'Ungültiger Modellname (Kleinbuchstaben, Ziffern, Punkte und Bindestriche).',
  ai_ack_required: 'Sie müssen bestätigen, dass Sie einen kostenpflichtigen Dienst einschalten.',
  month_invalid: 'Der Monat muss im Format JJJJ-MM angegeben werden.',
  forecast_history: 'Die Historie muss zwischen 8 und 104 Wochen liegen.',
  forecast_days: 'Die Anzahl der Tage muss zwischen 0 und 365 liegen.',
  forecast_review: 'Der Überprüfungszeitraum muss zwischen 1 und 180 Tagen liegen.',
  forecast_overstock: 'Die Schwelle für Überbestand muss zwischen 30 und 730 Tagen liegen.',
  ai_limit_invalid: 'Das Monatslimit muss zwischen 1 und 10.000 USD liegen.',
  ai_daily_limit_invalid: 'Das tägliche Anfragelimit muss zwischen 1 und 5000 liegen.',
  ai_image_reserve_invalid: 'Die Obergrenze pro Bild muss zwischen 0,001 und 5 USD liegen.',
  recommendation_window: 'Der Zeitraum muss zwischen 30 und 730 Tagen liegen.',
  recommendation_min_buyers:
    'Die Mindestanzahl verschiedener Käufer muss zwischen 2 und 50 liegen (aus Datenschutzgründen mindestens 2).',
  recommendation_confidence: 'Die Konfidenz muss zwischen 0 und 100 Prozent liegen.',
  recommendation_max: 'Die Anzahl der Empfehlungen pro Produkt muss zwischen 1 und 20 liegen.',
};
